
const SklHotelDetail = () => {
    return (
        <div className="skl-hotel-detail">
            <div className='skl-pr3 skeleton mb-2'></div>
            <div className='skl-pr2 skeleton w-30 mb-1'></div>
            <div className="bg-white mt-4">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="col-left skeleton skl-ex-radius">
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="col-right skeleton skl-ex-radius">
                        </div>
                    </div>
                    <div className="col-lg-12 mt-3">
                        <div className='skl-pr1 skeleton w-30 mb-2'></div>
                        <div className='skl-pr2 skeleton mb-1'></div>
                        <div className='skl-pr2 skeleton mb-1'></div>
                        <div className='skl-pr2 skeleton mb-1'></div>
                        <div className='skl-pr2 skeleton mb-1'></div>
                        <div className='skl-pr2 skeleton mb-1'></div>
                        <div className='skl-pr2 skeleton w-80 mb-1'></div>
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <div className='skl-pr1 skeleton w-20 mb-4'></div>
                <div className="d-flex">
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                    <li className="list-box skeleton mr-2"></li>
                </div>
            </div>
            <div className="mt-4">
                <div className="row">
                    <div className="col-lg-6">
                        <div className='skl-pr1 skeleton w-20 mb-2'></div>
                        <div className='skl-pr2 skeleton mb-1'></div>
                    </div>
                    <div className="col-lg-6 flex justify-content-end">
                        <div className="w-20 list-box skeleton rounded-4"></div>
                    </div>
                    <div className="col-lg-12 mt-3">
                        <div className="map skeleton"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SklHotelDetail